import { trigger, style, transition, animate } from '@angular/animations';

export const GoToTopAnimation = [
  trigger('show', [
    transition(':enter', [style({ marginBottom: '-20%' }), animate('.8s ease-out', style({ marginBottom: '0' }))]),
    transition(':leave', [style({ marginBottom: '0' }), animate('.8s ease-out', style({ marginBottom: '-20%' }))])
  ])
];
